import {UsersClient} from "@/api-client";
import {isNullOrWhiteSpace} from "@/extensions/string.helpers";
import {authService, AuthService} from "@/AuthService";

class UserInfo{
    private _userName = "";
    private _firstName = "";
    private _lastName = "";
    private _role = "";
    private _seafarerId = "";
    private _organizationId = "";
    private _organizationName = "";
    private _isAccessLinkUser = false;

    public get userName(){
        return this._userName;
    }
    
    public get fullName(){
        if (this._firstName || this._lastName)
            return `${this._firstName} ${this._lastName}`.trim();
    }

    public get firstName(){
        return this._firstName;
    }

    public get lastName(){
        return this._lastName;
    }

    public get role(){
        return this._role;
    }

    public get seafarerId(){
        return this._seafarerId;
    }

    public get organizationId(){
        return this._organizationId;
    }

    public get organizationName(){
        return this._organizationName;
    }

    public get isAccessLinkUser(){
        return this._isAccessLinkUser;
    }

    public async loadUserInfo(){
        if (!authService.isLoggedIn) {
            this._userName = "";
            this._firstName = "";
            this._lastName = "";
            this._role = "";
            this._seafarerId = "";
            this._organizationId = "";
            this._organizationName = "";
            this._isAccessLinkUser = false;
        } else {
            await new UsersClient().userInfo().then(user => {
                this._userName = isNullOrWhiteSpace(user.userName) ? "" : user.userName!;
                this._firstName = user.firstName;
                this._lastName = user.lastName;
                this._role = user.role || "";
                this._seafarerId = user.seafarerId || "";
                this._organizationId = user.organizationId || "";
                this._organizationName = user.organizationName || "";
                this._isAccessLinkUser = user.isAccessLinkUser;
            });
        }
    }
}

const userInfo : UserInfo = new UserInfo();
export default userInfo;